var _linearGradient, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticeTypeSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      fillOpacity: 1
    },
    d: "M39 16v25a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h17l11 11z",
    fill: "#50e6ff"
  }), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 -3890)",
    y2: -3900.4,
    y1: -3905.471,
    x2: 33.6,
    x1: 28.529,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3079d6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297cd2",
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccc",
      fillOpacity: 1
    },
    d: "M28 5v9a2 2 0 0 0 2 2h9L28 5z",
    fill: "url(#a)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#195bbc",
    d: "M32.206 27.318h-11a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm-14.5 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm14.5-8h-11a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm-14.5 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#42a4eb",
    d: "M32.206 34.318h-11a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm-14.5 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeTypeSurvey);
export default __webpack_public_path__ + "static/media/noticeTypeSurvey.6941eea24019c34f7a7fb09d5c73a2fd.svg";
export { ForwardRef as ReactComponent };